import action from "../../assets/img/landing/action.svg";

const ExternalLink = ({ icon, link, text }) => {
  return (
    <div className="external-link">
      <div>
        <img className="ex-icon" src={icon} alt={text} />
        <span>{text}</span>
      </div>
      <a href={link} target="__blank">
        <img src={action} alt="action" />
      </a>
    </div>
  );
};

export default ExternalLink;
